<div class="vendor-modal">

  <!-- header -->
  <div class="row">
    <div class="col-12">
      <h3 class="text-manax m-0 mb-4">
        <span class="pull-right">
          <button mat-icon-button type="button" (click)="dialog.close()">
            <i class="material-icons">close</i>
          </button>
        </span>
        <span class="text-purple-manax text-capitalize title-modal">
          Proveedor
        </span>
      </h3>
    </div>
  </div>

  <!-- body -->
  <div class="row" *ngIf="loading">
    <div class="col-12 mb-4">
      <div class="d-flex justify-content-center">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="!loading">
    <div class="col-12 vendor-content" [ngClass]="{darken: readOnly}" (click)="setEditable()">
      <form *ngIf="form" class="m-0" [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="row">
          <div class="col-md-3">
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label> Nombre </mat-label>
                  <input matInput name="name" formControlName="name" type="text" #nameInput [readonly]="readOnly"
                    [ngClass]="{ 'is-invalid': submitted && f['name'].errors }">
                </mat-form-field>
                <mat-error *ngIf="submitted && f['name']?.errors?.['required']">
                  Nombre Obligatorio
                </mat-error>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label> NIF </mat-label>
                  <input matInput name="nif" formControlName="nif" type="text" #nameInput [readonly]="readOnly"
                    [ngClass]="{ 'is-invalid': submitted && f['nif'].errors }">
                </mat-form-field>
                <mat-error *ngIf="submitted && f['nif']?.errors?.['required']">
                  NIF Obligatorio
                </mat-error>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <mat-form-field appearance="outline">
                  <mat-label> Dirección fiscal </mat-label>
                  <input matInput name="taxAddress" formControlName="taxAddress" type="text" #nameInput
                    [readonly]="readOnly" [ngClass]="{ 'is-invalid': submitted && f['taxAddress'].errors }">
                </mat-form-field>
                <mat-error *ngIf="submitted && f['taxAddress']?.errors?.['required']">
                  Dirección fiscal Obligatoria
                </mat-error>
              </div>
            </div>

            <div class="row" *ngIf="vendor._id && isDev">
              <div class="col-3">
                <label>
                  Borrada? <br>
                  <input name="isDeleted" formControlName="isDeleted" type="checkbox" [disabled]="readOnly">
                </label>
              </div>
              <div class="col-9">
                <mat-form-field appearance="outline">
                  <input matInput placeholder="Id" type="text" [value]="vendor._id" readonly>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="col-md-9">
            <div class="row">

              <!-- contacts -->
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-12 mb-2">
                    <div>
                      <span class="contact-group">Contactos</span>
                      <button *ngIf="!readOnly" type="button" class="btn btn-link text-success ml-2 p-0"
                        (click)="addContact()">
                        <i class="material-icons small">add</i> agregar
                      </button>
                    </div>
                    <div *ngIf="!contacts.controls?.length"> - sin contactos - </div>
                  </div>
                </div>
                <ng-container *ngFor="let p of contacts.controls; let i=index">
                  <div formArrayName="contacts">
                    <div [formGroupName]="i">

                      <div class="row pb-1">
                        <div class="col-md-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Nombre ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="firstname"
                              formControlName="firstname" required>
                            </mat-form-field>
                            <mat-error *ngIf="submitted && getContactGroup(i).get('firstname')?.errors?.['required']">
                              Nombre Obligatorio
                            </mat-error>
                        </div>
                        <div class="col-md-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Apellido ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="lastname"
                              formControlName="lastname">
                          </mat-form-field>
                        </div>
                        <div class="col-md-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Puesto ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="position"
                              formControlName="position">
                          </mat-form-field>
                        </div>
                        <div class="col-md-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Teléfono ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="phone" formControlName="phone">
                          </mat-form-field>
                        </div>
                        <div class="col-md-2">
                          <mat-form-field appearance="outline">
                            <mat-label>{{ 'Email ' + (i + 1) }}</mat-label>
                            <input matInput [readonly]="readOnly" type="text" name="email" formControlName="email">
                          </mat-form-field>
                        </div>
                        <div class="col-md-2 pl-md-0">
                          <button *ngIf="!readOnly" type="button"
                            class="btn btn-link text-danger m-0 mt-3 ml-0 p-0 small" (click)="removeContact(i)">quitar
                          </button>
                        </div>
                      </div>

                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="col-md-12">
            <div class="row" *ngIf="!readOnly">
              <div class="col-12 pt-4">
                <button mat-raised-button [disabled]="saving" type="submit" class="m-0 ml-1 pull-right btn btn-manax">
                  <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1"></span>
                  Guardar
                </button>
                <button mat-raised-button type="button" class="m-0 ml-1 pull-right btn btn-link"
                  (click)="cancelSubmit(); ">
                  Cancelar
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>